<main class="legal-page" role="main">
    <div class="legal-page-column">
        <h1 id="imprint-title" class="legal-page-title">{{ 'LEGAL.TITLE.IMPRINT' | translate }}</h1>
        <article class="legal-card"
                 aria-labelledby="imprint-title"
                 [innerHTML]="'LEGAL.IMPRINT.BODY' | translate">
        </article>
    </div>
</main>
